module.exports = __webpack_public_path__ + "img/8-1.8b61f3eb.jpg";